import React from 'react';
import emoji from '../utils/emoji';
import './index.scss';

interface IemojiPanelProps {
    removeDialog: () => void;
    selectCallback: (emoji: string) => void;
}

const emojiPanel = (props: IemojiPanelProps) => {
    const selectCallback = (emoji) => {
        props.selectCallback(emoji);
    };

    return (
        <div className="emoji-panel-wrap">
            <div className="panelBox">
                <i
                    className="w-e-icon-close w-e-panel-close"
                    onClick={() => props.removeDialog()}></i>
                <ul className="w-e-panel-tab-title">
                    <li className="w-e-item w-e-active">插入表情</li>
                </ul>
                <div className="w-e-panel-tab-content">
                    <div className="w-e-up-video-container">
                        <ul>
                            {Object.keys(emoji).map((item, index) => {
                                return (
                                    <li key={index} onClick={() => selectCallback(item)}>
                                        {
                                            <img
                                                src={`https://s.ampmake.com/www/image/emoticon/${emoji[item].icon}`}
                                                alt=""
                                            />
                                        }
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
            <div
                className="bigPanelcontainerShade"
                onClick={() => props.removeDialog()}></div>
        </div>
    );
};

export default emojiPanel;
